import { Link, Outlet } from "@remix-run/react"
import logo from "~/assets/mlnplogoheart.webp"

export default function Auth() {
  return (
    <>
      <div className="absolute top-0 insert-x-0 z-20">
        <div className="flex h-[70px] md:h-[140px] items-center mx-8 md:mx-16">
          <Link to="/" className="text-left flex flex-col flex-none justify-center item-start h-[70px] md:h-[140px]">
            <img
              className="block px-2 sm:px-4 lg:px-4 h-10 md:h-[70px]"
              style={{ width: "auto" }}
              src={logo}
              alt="Make Love Not Porn"
            />
          </Link>
        </div>
      </div>
      <Outlet />
    </>
  )
}
